<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div>{{departmentName}}</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialog" aria-label="Close dialog">close</mat-icon>
</div>

<mat-dialog-content>
  @for (item of valueProposalList; track item; let index = $index) {
    <mat-expansion-panel class="mb-8">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <span i18n="@@valueProposal">Value proposal</span> 
          <span class="ml-8">{{index + 1}}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="d-flex">
        @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
          <mat-icon class="cursor mr-auto" (click)="deleteValueProposal(item.id)" color="warn" i18n-label="@@deleteProposal" aria-label="Delete Value Proposal">delete_outline</mat-icon>
        }
        @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
          <mat-icon (click)="editValueProposal(item.id)" color="accent" class="cursor edit-icon" i18n-label="@@editProposal" aria-label="Edit Value Proposal">edit</mat-icon>
        }
        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
          <mat-icon class="cursor mr-auto" (click)="deleteValueProposal(item.id)" color="warn" i18n-label="@@deleteProposal" aria-label="Delete Value Proposal">delete_outline</mat-icon>
        }
        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
          <mat-icon (click)="editValueProposal(item.id)" color="accent" class="cursor edit-icon" i18n-label="@@editProposal" aria-label="Edit Value Proposal">edit</mat-icon>
          }
        @if (item.isAddedByManufacturer === true && (user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile') {
          <mat-icon class="cursor header-icon mr-auto" (click)="moveToNotUsedOnMobile(item.id)" i18n-label="@@moveToNotUsed" aria-label="Move to Not Used on Mobile">stay_current_portrait</mat-icon>
        }
        @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'manufacturer') {
          <mat-icon class="{{item.usedOnMobile ? 'cursor header-icon mr-auto' : 'header-icon-color cursor mr-auto'}}" 
                    (click)="item.usedOnMobile ? moveToNotUsedOnMobile(item.id) : moveToUsedOnMobile(item.id)" 
                    i18n-label="@@toggleUsedOnMobile" 
                    aria-label="Toggle Used on Mobile">
            stay_current_portrait
          </mat-icon>        }
      </div>

      <div i18n="@@salesSenario" class="mat-subtitle-1 mb-10" matTooltip ellipsisTooltip>Sales scenario</div>
      <div class="mat-caption mb-28 wrap" matTooltip ellipsisTooltip>{{item.salesScenario}}</div>

      <div i18n="@@productValue" class="mat-subtitle-1 mb-10" matTooltip ellipsisTooltip>Product value</div>
      <div class="mat-caption mb-28 wrap" matTooltip ellipsisTooltip>{{item.productValue}}</div>

      <div i18n="@@supportMaterials" class="mat-subtitle-1 mb-10" matTooltip ellipsisTooltip>Support materials</div>
      @for (material of item.supportMaterials ; track material; let index = $index) {
        <div class="mat-caption d-flex justify-content-between mb-10">
          @if (material.type === utils.supportMaterials.Link) {
            <span matTooltip ellipsisTooltip>{{truncate(material.path)}}</span>
          }
          @if (material.type !== utils.supportMaterials.Link) {
            <span matTooltip ellipsisTooltip>{{truncate(material.fileName)}}</span>
          }
            <a (click)="downloadMyFileAndLog(material)" href="{{material?.path}}" target="_blank">
              <mat-icon color="accent" class="cursor" i18n-label="@@downloadMaterial" aria-label="Download material">get_app</mat-icon>
            </a>
          </div>
      }
    </mat-expansion-panel>
  }
</mat-dialog-content>